const t = ["default", "sm"], I = {
  sm: "d-tablist--sm"
}, e = {
  inverted: "d-tablist--inverted"
}, s = {
  borderless: "d-tablist--no-border"
}, _ = {
  selected: "d-tab--selected"
};
export {
  _ as TAB_IMPORTANCE_MODIFIERS,
  s as TAB_LIST_IMPORTANCE_MODIFIERS,
  e as TAB_LIST_KIND_MODIFIERS,
  t as TAB_LIST_SIZES,
  I as TAB_LIST_SIZE_MODIFIERS
};
//# sourceMappingURL=tabs-constants.js.map
